<template>
    <div>
        <div class="" v-if="isShowPage" data-cy="container_mission_detail_condition"
             :class="[typePuzzle ? 'bg-mission-puzzle-detail-cond': typeMatch ? 'bg-mission-match-detail-cond bg-a-blue-002850' : type == 'game' ? 'bg-mission-detail-cond' : 'bg-mission-survey']"
             :style="{ 
                '--bg-mission-detail-cond-url': 'url(' + bgMissionDetailCondUrl() + ')',
                '--bg-mission-survey-url': 'url(' + bgMissionSurveyUrl() + ')',
                '--bg-mission-puzzle-detail-cond-url': 'url(' + bgMissionPuzzleDetailCondUrl() + ')',
                '--btn-play-url': 'url(' + btnPlayUrl() + ')',
                '--btn-play-v2-url': 'url(' + btnPlayV2Url() + ')'
             }">
            <MissionMatchBubbleLayer v-if="typeMatch" />
            <div class="relative z-10" :class="[typePuzzle ? 'px-4 pt-3 pb-6': typeMatch ? 'pt-[82px] px-9' : type == 'game' ? 'pt-9 px-9' : 'px-4 pt-3']">
                <div v-if="!typeMatch">
                    <div v-if="type == 'game'">
                        <div v-if="typePuzzle">
                            <div class="bg-a-blue-C9DEFF mx-auto w-full absolute top-7 right-0 left-0 h-28 z-0"></div>
                            <img class="mx-auto w-full absolute top-0 left-0 right-0 z-10" :src="imgTopMission" />
                        </div>
                        <div v-else class="">
                            <img class="mx-auto w-[277px] h-[90px]" :src="imgUrl('game','th')" v-if="localeCode == 1054" />
                            <img class="mx-auto w-[277px] h-[90px]" :src="imgUrl('game','en')" v-else />
                        </div>
                    </div>
                    <div class="pt-7 -mb-5 z-10 relative" v-else>
                        <img class="mx-auto" :src="imgUrl('survey','th')" v-if="localeCode == 1054" />
                        <img class="mx-auto" :src="imgUrl('survey','en')" v-else />
                    </div>
                </div>
                <div v-if="typePuzzle" class="bg-a-blue-A1C6FFF2 w-full p-5 mt-32 rounded-lg border-[3px] border-a-white-ffffff relative z-5">
                    <!-- <div class="font-bold text-18 text-center text-a-blue-2140a6 py-2">
                        {{ lbl.mission.detail_condition }}

                    </div> -->
                    <div class="h-[calc(90vh-275px)]">
                        <div class="h-full overflow-auto text-14 text-a-black-393939 mt-6"
                            v-html="missionDetail">
                        </div>
                    </div>
                    <div class="w-full  text-center mt-5 pb-4">
                        <button class="bg-a-blue-0064ff rounded-lg font-bold text-16 w-44 py-3 text-center text-a-blue-f2f5ff mx-auto"
                            data-cy="btn_mission_detail_condition_play"
                            @click="onClickPlay()">
                            {{ lbl.mission.btn_play }}
                        </button>
                    </div>
                </div>
                <div v-else-if="typeMatch" class="w-full relative z-10" data-cy="container_mission_detail_condition_match">
                    <div class="bg-a-gray-939399 rounded-[32px] pb-[10px] w-full h-[calc(100vh-295px)] relative flex flex-col min-h-0">
                        <div class="bg-a-white-ffffff rounded-[32px] px-5 py-6 m-max-375:py-4 w-full relative flex flex-1 flex-col min-h-0">
                            <div class="font-bold m-max-375:text-[28px] text-[40px] leading-normal text-center text-a-blue-0064ff shrink-0 m-max-375:leading-tight mb-4"
                                 data-cy="text_mission_detail_condition_match_title">
                                {{ lbl.mission.match_tc_title }}
                            </div>
                            <div class="mission-detail-cond flex-1 min-h-0 overflow-auto overscroll-contain text-14 sm:text-16 leading-normal text-a-black-000000"
                                 data-cy="text_mission_detail_condition_match_detail"
                                 v-html="missionDetail">
                            </div>
                            <button class="relative z-10 flex shrink-0 items-center justify-center bg-a-blue-0064ff rounded-[8px] border-0 py-3 px-6 font-medium text-16 sm:text-[18px] leading-normal text-a-white-ffffff mx-auto mt-5"
                                data-cy="btn_mission_detail_condition_match_start"
                                @click="onClickPlay()">
                                {{ lbl.mission.start_game }}
                            </button>
                            <img class="absolute top-[94px] right-[21px] w-[32px] h-[37px] z-20 pointer-events-none"
                                 data-cy="img_mission_detail_condition_wink_right"
                                 :src="imgWinkRight" />
                            <img class="absolute bottom-[22px] left-[21px] w-[32px] h-[37px] z-20 pointer-events-none"
                                 data-cy="img_mission_detail_condition_wink_left"
                                 :src="imgWinkLeft" />
                        </div>
                    </div>
                </div>
                <div v-else class="bg-a-white-ffffff w-full py-8 px-4.5 rounded-lg h-[calc(100vh-295px)] relative">
                    <div class="font-bold text-18 text-center text-a-blue-2140a6 py-2">
                        {{ lbl.mission.detail_condition }}

                    </div>
                    <div class="">
                        <div class="h-[calc(100vh-410px)] overflow-auto text-14 text-a-gray-666666"
                            v-html="missionDetail">
                        </div>
                    </div>
                    <div v-if="!typePuzzle && type == 'game'" class="absolute -bottom-6 left-0 right-0 w-full  text-center z-50">
                        <button class="btn-play-v2 font-medium text-25 text-center text-a-blue-f2f5ff mx-auto"
                            data-cy="btn_mission_detail_condition_play_v2"
                            @click="onClickPlay()">
                            {{ lbl.mission.btn_play }}
                        </button>
                    </div>
                </div>
                <div class="w-full  text-center mt-5 pb-4" v-if="!typePuzzle && !typeMatch">
                    <!-- <button class="btn-play font-bold text-18 text-center text-a-blue-f2f5ff mx-auto"
                        @click="onClickPlay()" v-if="type == 'game'">
                        {{ lbl.mission.btn_play }}
                    </button> -->
                    <button class="btn-play font-bold text-18 text-center text-a-blue-f2f5ff mx-auto"
                        data-cy="btn_mission_detail_condition_survey"
                        @click="onClickSurvey()" v-if="type != 'game'">
                        {{ lbl.mission.btn_survey }}
                    </button>
                </div>
            </div>
        </div>
        <div :class="typeMatch ? 'bg-mission-match-detail-cond bg-a-blue-002850' : 'bg-mission-coming-soon'"
             data-cy="container_mission_detail_condition_coming_soon" v-else 
             :style="typeMatch ? {} : { '--bg-mission-coming-soon-url': 'url(' + bgMissionComingSoonUrl() + ')' }">
            <MissionMatchBubbleLayer v-if="typeMatch" />
            <div class="coming-soon flex flex-col my-auto justify-center items-center relative z-10">
                <div class="text-16 text-center pb-4" :class="typeMatch ? 'text-a-white-ffffff' : 'text-a-blue-2140a6'">
                    {{ lbl.mission.detail_coming_soon }}
                </div>
                <div>
                    <img class="w-16" :src="imgComingSoon" />
                </div>
            </div>
        </div>
        <div v-if="type == 'game' && !typePuzzle" class="fixed bottom-0 left-0 right-0 z-0 flex justify-center">
            <img class="bg-bottom-mission-detailcond" :src="imgBottomMission" alt="">
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//helper
import ConfigManager from '@/config/ConfigManager.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import AccountHelper from '@/helper/AccountHelper';
import CacheHelper from '@/helper/CacheHelper';
//service
import { SubDashboardConfigBuilder } from '@/core/Campaign/config/DashboardConfigModel.js';
import BzbsDashboard from '@/core/Campaign/service/BzbsDashboard.js';
import BzbsAuth from '@/core/Account/service/BzbsAuth';
import { WebInterfaceController } from '@/module/Detail/controller/WebInterfaceController.js';
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import MissionService from '../service/MissionService.js';
import MissionMatchBubbleLayer from './MissionMatchBubbleLayer.vue';

export default {
    name: 'DetailAndConditionGame',
    mixins: [LocaleMixin, ModalMixin],
    components: {
        MissionMatchBubbleLayer,
    },
    data: function(){
        return {
            type: '',
            index: null,

            campaign: null,
            surveyDashboard: null,
            gameDashboard: null,
            gamePuzzleDashboard: null,
            gameMatchDashboard: null,
            missionDetail: null,
            isShowPage: false,
            typePuzzle: false,
            typeMatch: false,
            gameConfig: [],
            gameConfigPuzzle: [],
            gameConfigMatch: null,
            imgComingSoon: null,
            imgTopMission: null,
            imgBottomMission: null,
            imgWinkLeft: null,
            imgWinkRight: null,
        }
    },
    created: async function() {
        this.type = this.$route.params.type;
        const typeGame = this.$route.params.key;
        this.typePuzzle = this.type == 'game' && typeGame == 'puzzle';
        this.typeMatch = this.type == 'game' && typeGame == 'match';
        this.getBgDetailCondUrl();
        if(this.type == 'game'){
            if (this.typePuzzle) {
                this.gamePuzzleDashboard = await this.getGamePuzzleDashboard();
                this.checkShowPuzzleDashboard();
                let detail = await this.getMissionGamePuzzleDetailBlob();
                this.missionDetail = this.localeCode == 1054 ? detail.detail_th : detail.detail_en;
            } else if (this.typeMatch) {
                this.gameMatchDashboard = await this.getGameMatchDashboard();
                this.checkShowMatchDashboard();
                let detail = await this.getMissionGameMatchDetailBlob();
                if (detail) {
                    this.missionDetail = this.localeCode == 1054 ? detail.detail_th : detail.detail_en;
                }
            } else {
                this.gameDashboard = await this.getGameDashboard();
                this.checkShowDashboard();
                let detail = await this.getMissionDetailBlob();
                this.missionDetail = this.localeCode == 1054 ? detail.detail_th : detail.detail_en;
            }

        }else{
            this.index = this.$route.params.key;
            this.surveyDashboard = await this.getSurveyDashboard();
            this.missionDetail = await this.getSurveyDetail();

            if(this.surveyDashboard.id){
                this.isShowPage = true;
            }
        }

    },
    mounted: function(){
        this.tracking.screenName('mission')
        if(this.$route.params.type == 'game'){
            this.tracking.event('mission_game', 'mission_game', null, null)
        } else {
            this.tracking.event('mission_survey', 'mission_survey', null, null)
        }
    },
    methods: {
        //#region mission game
        getGameDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().gameDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            console.log('game', res);
                            //this.arrDashboardFlag1 = res;
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        getGamePuzzleDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().gamePuzzleDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        getGameMatchDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().gameMatchDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        getMissionDetailBlob: function () {
            return new Promise((resolve) => {
                MissionService.getMissionDetailConfig()
                    .subscribe({
                        next: (res) => {
                            console.log('config', res)
                            resolve(res.game);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            resolve(null);
                        }
                    });
            });
        },
        getMissionGamePuzzleDetailBlob: function () {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.getMissionGamePuzzleDetailConfig()
                    .subscribe({
                        next: (res) => {
                            this.modal.loadingModal.hide();
                            resolve(res.game);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            this.modal.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        getMissionGameMatchDetailBlob: function () {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.getMissionGameMatchDetailConfig()
                    .subscribe({
                        next: (res) => {
                            this.modal.loadingModal.hide();
                            resolve(res.game);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            this.modal.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        checkShowDashboard: function(){
            if(this.gameDashboard.length <= 0) return;

            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDate(this.gameDashboard[0].startDate);
            let end = DatetimeHelper.unixTimestampToDate(this.gameDashboard[0].endDate);

            if(currentDate >= start && currentDate <= end){
                this.isShowPage = true;
            }else{
                this.isShowPage = false;
            }
        },
        checkShowPuzzleDashboard: function(){
            if(this.gamePuzzleDashboard.length <= 0) return;

            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDate(this.gamePuzzleDashboard[0].startDate);
            let end = DatetimeHelper.unixTimestampToDate(this.gamePuzzleDashboard[0].endDate);

            if(currentDate >= start && currentDate <= end){
                this.isShowPage = true;
            }else{
                this.isShowPage = false;
            }
        },
        checkShowMatchDashboard: function(){
            if(!this.gameMatchDashboard || this.gameMatchDashboard.length <= 0) return;

            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDate(this.gameMatchDashboard[0].startDate);
            let end = DatetimeHelper.unixTimestampToDate(this.gameMatchDashboard[0].endDate);

            if(currentDate >= start && currentDate <= end){
                this.isShowPage = true;
            }else{
                this.isShowPage = false;
            }
        },
        onClickPlay: function(){
            this.tracking.event('mission_game', 'mission_game_play', null, null);
            if (this.typePuzzle) {
                let cache = new CacheHelper('session');
                let targetPoint = cache.getCache('target_point');
                let msg = Util.stringFormat(this.lbl.mission.game_puzzle_confirm.msg, targetPoint);
                this.modal.missionConfirmModal
                    .clearModal()
                    .setTitle(this.lbl.mission.game_puzzle_confirm.title)
                    .setMsg(msg)
                    .setBtnOk(this.lbl.mission.game_puzzle_confirm.btn)
                    .setBtnCancel(this.lbl.mission.game_puzzle_confirm.close)
                    .show();

                this.modal.missionConfirmModal.onClickOk(() =>{
                    this.tracking.event('mission_game', 'mission_game_Start', null, null);
                    this.playGamePuzzle();
                });

                this.modal.missionConfirmModal.onClickCancel(() =>{
                    this.tracking.event('mission_game', 'mission_game_cancel', null, null);
                });

            } else if (this.typeMatch) {
                this.tracking.event('mission_game', 'mission_game_Start', null, null);
                this.playGame();
            } else {
                this.modal.missionAlertModal
                    .clearModal()
                    .setTitle(this.lbl.mission.game_confirm.title)
                    .setMsg(this.lbl.mission.game_confirm.msg)
                    .setBtnOk(this.lbl.mission.game_confirm.btn)
                    .show();

                this.modal.missionAlertModal.onClickOk(() =>{
                    this.tracking.event('mission_game', 'mission_game_Start', null, null);
                    this.playGame();
                });

                this.modal.missionAlertModal.onClickCancel(() =>{
                    this.tracking.event('mission_game', 'mission_game_cancel', null, null);
                });
            }
        },
        getGameConfig: async function(){
            return new Promise((resolve)=>{
                MissionService.getGameConfig().subscribe({
                    next: (res)=>{
                        this.findMissionGame(res.data)
                        resolve(res.data)
                    },
                    error: (err)=>{
                        this.errorApi(err)
                        resolve(null)
                    }
                })
            })
        },
        findMissionGame: function(find) {
            this.gameConfig = find.find((item) => item.PartitionKey != 'puzzle' && item.PartitionKey != 'match');
            this.gameConfigPuzzle = find.find((item) => item.PartitionKey == 'puzzle');
            this.gameConfigMatch = find.find((item) => item.PartitionKey == 'match');
        },
        playGame: async function () {
            await this.getGameConfig()
            let gameConfig = this.typeMatch ? this.gameConfigMatch : this.gameConfig;
            if(gameConfig == null){
                return
            }
            let token = AccountHelper.getToken()

            // game config can load from blob if need
            let payload = {
                api:{
                    api: ConfigManager.getApiUrl(),
                    apiModule: ConfigManager.getApiModuleUrl()
                },
                locale: this.localeCode,
                returnUrl: window.location.origin + "/mission",
                config: {
                    duration: gameConfig.Timer,
                    baseGameSpeed: 5,
                    velocity: 500,
                    obstacleTrigger: 1000,
                    point: gameConfig.Point,
                    gameType: gameConfig.PartitionKey,
                    gameId: gameConfig.RowKey,
                    tracePlan: gameConfig.TracePlan,
                    startDate: gameConfig.StartDate,
                    endDate: gameConfig.EndDate,
                    targetPoint: gameConfig.TargetPoint,
                    timer: gameConfig.Timer,
                    pointPerTimes: gameConfig.PointPerTimes,
                    debug: false
                }
            }

            // create session
            BzbsAuth.apiCreateAccessKey(token, JSON.stringify(payload)).subscribe({
                next: (accKey) => {
                    // console.log(accKey)
                    let gameLandingUrl = ConfigManager.getGameLanding()
                    let gamePath = this.typeMatch ? 'flipmatch' : 'seaArcade'
                    let url = `${gameLandingUrl}/bbl/${gamePath}?accKey=${encodeURIComponent(accKey.accessKey)}`
                    window.location = url
                },
                error: (err) => {
                    this.errorApi(err)
                }
            })
        },
        playGamePuzzle: async function () {
            await this.getGameConfig()
            console.log(this.gameConfigPuzzle);
            if(this.gameConfigPuzzle == null){
                return
            }
            let token = AccountHelper.getToken()

            // game config can load from blob if need
            let payload = {
                api:{
                    api: ConfigManager.getApiUrl(),
                    apiModule: ConfigManager.getApiModuleUrl()
                },
                locale: this.localeCode,
                returnUrl: window.location.origin + "/mission",
                config: {
                    point: this.gameConfigPuzzle.Point,
                    gameType: this.gameConfigPuzzle.PartitionKey,
                    gameId: this.gameConfigPuzzle.RowKey,
                    tracePlan: this.gameConfigPuzzle.TracePlan,
                    startDate: this.gameConfigPuzzle.StartDate,
                    endDate: this.gameConfigPuzzle.EndDate,
                    pointPerTimes: this.gameConfigPuzzle.PointPerTimes,
                    targetPoint: this.gameConfigPuzzle.TargetPoint,
                    timer: this.gameConfigPuzzle.Timer,
                    debug: false
                }
            }

            // create session
            BzbsAuth.apiCreateAccessKey(token, JSON.stringify(payload)).subscribe({
                next: (accKey) => {
                    // console.log(accKey)
                    let gameLandingUrl = ConfigManager.getGameLanding()
                    let url = `${gameLandingUrl}/bbl/candypuzzle?accKey=${encodeURIComponent(accKey.accessKey)}`
                    window.location = url
                },
                error: (err) => {
                    this.errorApi(err)
                }
            })
        },
        //#endregion mission game

        //#region mission survey
        getSurveyDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().surveyDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            console.log('survey', res);
                            //this.arrDashboardFlag1 = res;
                            let dashboard = res[this.index];
                            console.log('dashboard', dashboard)

                            resolve(dashboard);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        getSurveyDetail: function(){
            if(!this.surveyDashboard.id) return;

            let campaignId = this.surveyDashboard.id;
            let campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            return new Promise((resolve) => {
                BzbsCampaign.apiGetCampaignDetail(campaignConfig).subscribe((campaign) => {
                    console.log('campaign', campaign)
                    this.campaign = campaign;
                    resolve(campaign.detail);
                }, (err) => {
                    this.errorApi(err);
                    console.log(err);
                    resolve(null);
                });
            });
        },
        onClickSurvey: function(){
            this.tracking.event('mission_game', 'mission_game_play', null, null);

            let webInterface = new WebInterfaceController(this.campaign);
            webInterface.setPage('mission');
            webInterface.openInterface();
        },
        //#endregion mission servey

        // Image URL functions
        imgUrl: function(type, lang) {
            var appId = ConfigManager.getAppId();
            if (this.typeMatch) {
                this.imgBottomMission = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-bottom-game-flip.png`;
            } else {
                this.imgBottomMission = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-bottom-mission-detailcond.png`;
            }
            if (type == 'game') {
                return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-header-game-sec-${lang}.png`;
            } else {
                return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-header-survey-${lang}.png`;
            }
        },
        getBgDetailCondUrl: function() {
            var appId = ConfigManager.getAppId();
            this.imgComingSoon = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-coming-soon.png`;
            this.imgTopMission = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-top-mission-game.png`;
            if (this.typeMatch) {
                this.imgBottomMission = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-bottom-game-flip.png`;
                this.imgWinkLeft = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/img-wink-left.png`;
                this.imgWinkRight = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/img-wink-right.png`;
            } else {
                this.imgBottomMission = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-bottom-mission-detailcond.png`;
            }
        },  
        bgMissionDetailCondUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-mission-detailcond.jpg`;
        },
        bgMissionSurveyUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-mission-survey.jpg`;
        },
        bgMissionPuzzleDetailCondUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-mission-game.png`;
        },
        bgMissionComingSoonUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-mission-detailcond.jpg`;
        },
        bgCoralHeaderUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-coral.png`;
        },
        btnPlayUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-btn.png`;
        },
        btnPlayV2Url: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-btn-v2.png`;
        }

    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.bg-mission-detail-cond {
    height: calc(100vh - 23px);
    background-image: var(--bg-mission-detail-cond-url);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom center;
    margin-top: -52px;

    @media(max-height: 680px){
        // height: 100%;
        background-attachment: fixed;
    }
}
.bg-mission-survey {
    height: calc(100vh - 23px);
    background-image: var(--bg-mission-survey-url);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom center;
    margin-top: -52px;

    @media(max-height: 680px){
        height: 100%;
        background-attachment: fixed;
    }
}
.bg-bottom-mission-detailcond {
    height: 100%;
    max-height: 199px;
    width: 100%;
    max-width: 500px;
}
.bg-mission-puzzle-detail-cond {
    height: calc(100vh - 23px);
    background-image: var(--bg-mission-puzzle-detail-cond-url);
    background-repeat: no-repeat;
    background-size: 100% 85%;
    background-position: bottom center;
    margin-top: -52px;

    @media(max-height: 680px){
        // height: 100%;
        background-attachment: fixed;
    }
}
.bg-mission-match-detail-cond {
    position: relative;
    overflow: hidden;
    height: calc(100vh - 23px);
    margin-top: -52px;

    @media(max-height: 680px){
        background-attachment: fixed;
    }
}
.bg-mission-coming-soon {
    height: calc(100vh - 23px);
    background-image: var(--bg-mission-coming-soon-url);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom center;
    margin-top: -52px;
}
.bg-coral-header{
    height: 155px;
    background-image: var(--bg-coral-header-url);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
}
.btn-play{
    min-width: 192px;
    height: 67px;
    background-image: var(--btn-play-url);
    background-position: top center;
    background-repeat: no-repeat;
}
.btn-play-v2{
    min-width: 182px;
    height: 55px;
    background-image: var(--btn-play-v2-url);
    background-position: top center;
    background-repeat: no-repeat;
}

.coming-soon{
    min-height: calc(100vh - 120px);
}
</style>
<style lang="scss">
.mission-detail-cond{
    ul{
        list-style: disc;
        padding: 5px 0{
            left: 20px;
        }

        li{
            padding: 5px 0;
        }
    }
    ol{
        list-style: auto;
        padding-left: 35px;

        li{
            padding: 5px 0;
        }
    }
}
</style>
